import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

// /signup deep link (spec §5.2): open the auth dialog in signup mode over the
// booking page. `user === undefined` = auth not resolved yet → render nothing,
// like the /profile and /reset guards in App.jsx.
const SignupRedirect = ({ user, openAuthDialog }) => {
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email') || '';
    const resolved = user !== undefined;
    const loggedOut = resolved && !user;

    useEffect(() => {
        if (loggedOut) {
            openAuthDialog('signup', { email });
        }
    }, [loggedOut, email, openAuthDialog]);

    if (!resolved) {
        return null;
    }
    return <Navigate to="/booking" replace />;
};

export { SignupRedirect };
